export default __webpack_public_path__ + "static/media/brands.2d47aded.png";